var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 板块： "),_vm._l((_vm.plates),function(plate){return _c('div',{key:plate.index},[_c('b-badge',{staticClass:"m-1 float-left"},[_vm._v(_vm._s(plate[1]))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }